import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { QualificationSection } from './components/QualificationSection';
import { SolutionSection } from './components/SolutionSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
export function App() {
  return <main className="w-full min-h-screen bg-[#0D0D0D] text-[#F5F0E8] overflow-x-hidden selection:bg-[#D4A853] selection:text-[#0D0D0D]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <QualificationSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <FAQSection data-id="element-6" />

      {/* Simple Footer */}
      <footer className="py-12 text-center text-[#A89F91]/30 text-sm bg-[#0D0D0D]" data-id="element-7">
        <p data-id="element-8">© 2024 REINICIO TOTAL 35+. Todos los derechos reservados.</p>
      </footer>
    </main>;
}